import { computed } from '@vue/composition-api'
import Progress from '@/components/@order/Progress'

export default {
  components: { Progress },
  setup(props, context) {
    const { $store } = context.root

    const order = computed(() => $store.state.driver.order)
    return {
      order,
    }
  },
}
